import React from 'react'
import Content from './Content'
import Button from './Button'
import bg from "../images/IMG_0095.jpg"
const Restaraunt = () => {
  return (
        <div className="container flex flex-col w-4/5 max-h-prose mx-auto place-self-center text-center">
      
        <Content title="RESTARAUNT"
        subtitle="World of Esquite Taste"/>
        <div className="container flex flex-col md:flex-row  mx-auto">
            <div className="w-full bg-cover place-self-center">
                <img src={bg} alt="img"/>
            </div>
            <div className="container text-white place-self-center">
                <div className=" mt-4 mb-4 w-3/4 mx-auto h-3/4 z-10 ">
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quod neque minus, ducimus dolore veniam aspernatur optio quibusdam itaque, placeat, aliquam sit hic! Nam nihil fugiat aut totam, sequi unde nostrum.</p>
                    <div className="m-3 flex flex-row justify-center p-5  space-x-6">
                        <Button href="/restaraunt" label="RESTARAUNT" isColour={true}/>
                       <Button href="/menu" label="MENU" />     

                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}
export default Restaraunt